<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> مسیرهای پرتردد  </span>

    </div>

</div>

<!-- اطلاعات دریافت شده  -->

<main style="direction: rtl;" class="py-3 px-2">

    <!-- نمایش اطلاعات -->

    <div class="row gx-0 gy-2 gx-md-2 gy-md-2 border border-2 rounded p-2" >

        <!-- سرچ باکس -->

        <div class="col-12 col-md-10 searchbox-container">

            <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)"> 

        </div>

        <!-- افزودن -->

        <div class="col-12 col-md-auto add-button-container">

            <button class="btn btn-success w-100" (click)="newTripSAD()"> 
                
                &nbsp; &nbsp; افزودن &nbsp; &nbsp; 
            
            </button>
            
        </div>

        <!-- جدول اطلاعات -->

        <div class="col-12 section border border-2 mt-3" style="height:calc(100vh - 150px);overflow: auto;" id="print-table">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="col-12 text-center">
        
                        <th class="text-center col-1"> # </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> نام </th>
            
                        <th class="text-center"> کد شهر </th>

                        <th class="text-center"> نام شهر </th>

                        <th class="text-center"> آدرس </th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_TripSAD;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td>
                            
                            <div class="d-flex justify-content-around align-items-center">

                                <i class="fa fa-edit fa-lg text-primary pointer" (click)="newTripSAD(true,item,i)" title=" ویرایش"></i>

                                <i class="fa fa-map-marker fa-lg text-dark pointer" (click)="showOnMap(item)" title="نمایش موقعیت"></i>

                                <i class="fa fa-trash fa-lg text-danger pointer" (click)="removeTripSAD(item,i)" title="حذف"></i>

                            </div>
                            
                        </td>

                        <td> {{ item.strName }} </td>

                        <td> {{ item.strCity | faNum }} </td>

                        <td> {{ item.strStateName | faNum }} </td>

                        <td style="width: 300px;text-wrap: wrap;"> {{ item.strAddress | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- مدال افزودن و ویرایش -->

<div class="modal fade" id="TripSAD_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content" style="direction: rtl;">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش' : 'افزودن'  }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_TripSAD" class="container-fluid row gx-2 gy-2 p-2">

                    <!-- عنوان -->

                    <div class="position-relative col-12 col-md-6 p-2">
                
                        <label class="mb-2 text-muted"> عنوان </label>
            
                        <input class="form-control p-2 text-center" formControlName="strName">
            
                    </div>

                    <!-- شهر -->

                    <div class="position-relative col-12 col-md-6 p-2">

                        <label class="mb-2 text-muted"> شهر </label>

                        <custom-filter *ngIf="showFilter"

                            [strValue]="returnStrValue('strCity',mdl_TripSAD.get('strCity')?.value,list_City,'strCityName')"
                    
                            [strComment]="'strCityName'"
                    
                            [stylesArray]="['padding-top: 10px','text-align: center']"
                    
                            [str_Placeholder]="'نام شهر را جستجو کنید'"
                    
                            [lst_Main]="list_City" 
                    
                            [lst_SearchKey]="['strCityName']"
                    
                            [isDisabled]="false"
                            
                            (hideOptions)="mdl_TripSAD.get('strCity')?.setValue($event?.strCity ? $event.strCity : '')">
                
                        </custom-filter>

                    </div>

                    <!-- آدرس -->

                    <div class="position-relative col-12 p-2">
            
                        <label class="mb-2 text-muted"> آدرس </label>
            
                        <input class="form-control p-2" 

                            placeholder="بعد از وارد کردن آدرس  کلید Enter را فشار دهید"

                            (keyup.enter)="getLocationGeocoding(0, 0, $event.target.value)"
                       
                            formControlName="strAddress">

                        <div class="position-absolute bg-warning rounded pointer" style="top:12px;left:10px;">

                            <i class="fa fa-map-marker fa-lg p-2 px-2 px-md-3" (click)="newOpenMap(0)" title="نمایش روی نقشه"> </i>

                        </div>
            
                    </div>

                    <!-- طول جغرافیایی -->

                    <div class="position-relative col-12 col-md-6 p-2">
                
                        <label class="mb-2 text-muted"> طول جغرافیایی </label>
            
                        <input class="form-control p-2 text-center" formControlName="fLon">
            
                    </div>

                    <!-- عرض جغرافیایی -->

                    <div class="position-relative col-12 col-md-6 p-2">
                
                        <label class="mb-2 text-muted"> عرض جغرافیایی </label>
            
                        <input class="form-control p-2 text-center" formControlName="fLat">
            
                    </div>

            
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button [ngClass]="bEditMode ? 'btn btn-primary' : 'btn btn-success' "(click)="addTripSAD()">

                    &nbsp; {{ bEditMode ? 'ویرایش' : 'ذخیره' }} &nbsp;

                </button>


                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال جستجوی آدرس در نقشه -->

<div class="modal fade" id="maplat" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI" [ngStyle]="{'height' : bMapMode ? 'auto' : '20px' }">

                <h5 class="modal-title"> نقشه </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map" class="position-sticky w-100 " style="height: 650px;">

                <!-- اگر در حالت نمایش بر روی نقشه نبود -->

                <ng-container *ngIf="!bMapMode">

                    <div [formGroup]="mdl_TripSAD" class="d-flex justify-content-around flex-wrap position-absolute dirI bg-th-yellow w-100 p-1 border-bottom border-info" style="z-index: 1000; margin-bottom: 10px;">

                        <div class="d-flex align-items-center px-2 py-2 col-11">
    
                            <label for="addressBar"> آدرس </label>
    
                            <input name="addressBar" formControlName="addressBar"
    
                                placeholder="آدرس خود را جستجو کنید ..."
    
                                (keyup.enter)="getLocationGeocoding(1, mapMode, $event.target.value)" type="text"
    
                                class="rounded w-100 ms-2 p-1" style="border: none;">
                        </div>
    
                    </div>

                </ng-container>

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

            <!-- اگر در حالت نمایش بر روی نقشه نبود -->

            <ng-container *ngIf="!bMapMode">

                <div class="modal-footer d-flex justify-content-end">

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                    <button class="btn btn-success px-4" (click)="confirmMap()">
    
                        تایید
    
                    </button>
    
                </div>
                
            </ng-container>

        </div>

    </div>

</div>